import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';

type Props = {
  title: string | ReactNode;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
};

export const Card = ({ title, children, disabled, className }: Props) => {
  return (
    <section css={style} className={className}>
      <Heading
        level={3}
        css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), transition: 'color 1s' }}
        color={disabled ? 'disabled' : 'default'}
      >
        {title}
      </Heading>
      {children}
    </section>
  );
};

const style = css`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
  padding: ${theme.spacing(3)};
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.light};
`;
